<template>
  <v-app :class="$route.name">
    <!-- <div class="" v-if="isWeixin() == 1">1111111111</div> -->
    <!-- <transition :name="direction"> -->
    <div v-if="isWeixin() && isShowWxQQMaskTips == 1" class="mask">
      <img :src="`${_cdn}/vx/vvvv.png`" alt="" v-if="isiOS" />
      <img :src="`${_cdn}/vx/qqqq.png`" alt="" v-if="isAndroid" />
    </div>
    <template v-else>
      <template v-if="appReady">
        <keep-alive :include="cachedViews">
            <router-view :key="key" class="" v-if="isRouterAlive" />
          </keep-alive>
        <!-- <router-view :key="key" class="" v-if="isRouterAlive " /> -->
        <notice-popup></notice-popup>
        <!-- <site-notice-popup></site-notice-popup> -->
        <template v-if="isShowPoupBox">
          <component :is="noticePopType" />
        </template>
        <OffLineAlert></OffLineAlert>
      </template>
      <div v-else style="height: 100%" class="d-flex justify-center align-center">
        <rotate-square2></rotate-square2>
      </div>
      <!-- <v-dialog v-model="$store.state.app.success" content-class="successDialog" :hide-overlay="true" >
      <div class="head"><i></i></div>
      <div>dsfffffffffffffffffffffffffffff</div>
      <div></div>
    </v-dialog> -->
      <ChangeLinedialog></ChangeLinedialog>
      <!-- </transition> -->
    </template>
  </v-app>
</template>

<script>
import { throttle } from 'throttle-debounce'
import { RotateSquare2 } from 'vue-loading-spinner'
import noticePopup from '@c/noticePopup.vue'
import appConfigMixins from '@c/mixins/appConfig.mixins'
import OffLineAlert from '@c/OffLineAlert'
import ChangeLinedialog from '@c/changeLinedialog'
export default {
  provide() {
    return {
      reload: this.reload
    }
  },
  name: 'App',
  components: {
    noticePopup,
    RotateSquare2,
    OffLineAlert,
    ChangeLinedialog,
    default: () => import('@c/siteNoticePopup'),
    dfcp: () => import('@c/siteNoticePopupDf'),
    VeniceDark: () => import('@c/siteNoticePopupVeniceDark'),
    list: () => import('@c/siteNoticePopupList')
  },
  mixins: [appConfigMixins],
  data: () => ({
    isRouterAlive: true,
    appReady: false,
    isAndroid: false,
    isiOS: false,
    direction: 'slide-right',
    cachedViews: ['PictureWarehouse']
  }),
  created() {
    this.appinit()
    this.throttleUpdateNoRead = throttle(180000, this.updateNoRead)
    document.addEventListener('visibilitychange', this.toTryUpdateNoread)

    this.$store.commit('app/setChangeLineState', {
      show: false,
      step: -1,
      errorText: '',
      mode: -1
    })
  },
  computed: {
    isShowPoupBox() {
      return this.$route.path != '/GameLoadingPage'
    },
    noticePopType() {
      //return 'dfcp'
      let flag = 'default'
      try {
        flag = this._config.app_config.configValue.template.noticePop || 'default'
      } catch (e) {
        flag = 'default'
      }
      return flag == undefined ? 'default' : flag
    },

    appTheme() {
      return this._config.app_config.configValue.app_theme || JSON.parse(localStorage.NEWAPPCONFIG)
    },
    _cdn() {
      return this.$store.getters['app/cdn']
    },
    isShowWxQQMaskTips() {
      return this._config.app_config.configValue.isShowWxQQMaskTips == 0 ? 0 : 1
    },
    key() {
      // if (
      //     this.$route.name == "lotterycredit" ||
      //     this.$route.name == "lotterypurchase"
      // ) {
      //     return this.$route.name + Date.now();
      // }
      return this.$route.name
    },
    token() {
      return this.$store.getters['user/getUserToken']
    },
    userInfo() {
      return this.$store.state.user.userInfo
    },
  },
  mounted() {
    let dom = document.querySelector('.vc-popup-conatiner')
    dom.addEventListener('touchmove', function(e) {
      e.preventDefault()
    })
    this.openBrowser()
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
    },
    async appinit() {
      if (localStorage.NEWAPPCONFIG && Object.keys(JSON.parse(localStorage.NEWAPPCONFIG)).length > 2) {
        this.initTheme()
        this.appReady = true
      }
      let promistlist = []
      promistlist.push(this.$store.dispatch('user/initStateByUrlParameter'))
      promistlist.push(this.$store.dispatch('app/getAppConfig'))
      promistlist.push(this.$store.dispatch('sysParameter/getParameter'))

      this.$store.commit('thirdparty/setplatformList', [])
      this.$store.commit('sysParameter/setShowDownBar', true)
      this.$store.commit('sysParameter/setShowSignEntry', true)
      this.$store.dispatch('user/getUserLevelList')
      this.$store.commit('wallet/setcurrencyType', '') //更新下配置避免缓存无法更新

      const user_token = this.$store.state.user.token
      if (!!user_token) {
        this.$store.dispatch('user/getProxyRp') //获取返点信息
      }

      try {
        await Promise.all(promistlist)
      } catch {
        this.appReady = true
      }

      const config = this.$store.state.app.appConfig
      //设置script
      if (config.import_script_config && config.import_script_config.configValue.length > 0) {
        config.import_script_config.configValue.forEach(item => {
          if (item.isEnable == 1 && item.src && item.platform.includes('h5')) {
            const hm = document.createElement('script')
            const attributes = item.attributes
            const hostIri = item.src
            hm.src = hostIri
            if (typeof attributes == 'object') {
              for (let key in attributes) {
                hm[key] = attributes[key]
              }
            }
            document.body.appendChild(hm)
          }
        })
      }

      //设置title
      let isWeixin = this.isWeixin()
      if (isWeixin != 1) {
        document.title = config.site_config.configValue.title || config.site_config.configValue.name
      }

      const ico = config.app_config.configValue.ico
        ? config.app_config.configValue.ico
        : config.site_config.configValue.ico

      //设置ico
      const link = document.createElement('link')
      link.setAttribute('href', ico)
      link.setAttribute('rel', 'shortcut icon')
      document.getElementsByTagName('head')[0].appendChild(link)

      // 设置应用名
      const app_site_name = config.site_config.configValue.name || ''
      if (app_site_name) {
        const head = document.getElementsByTagName('head')[0]
        const metaEle = document.createElement('mata')
        metaEle.setAttribute('name', 'application-name')
        metaEle.setAttribute('content', app_site_name)
        head.appendChild(metaEle)
      }

      //设置桌面快捷方式图标
      let webAppLogo = ''
      try {
        webAppLogo = config.site_config.configValue['app_logo'].find(item => item.name == 'webAppLogo').url
      } catch {}
      if (webAppLogo) {
        const head = document.getElementsByTagName('head')[0]
        const webAppLogoLink = document.createElement('link')
        webAppLogoLink.setAttribute('rel', 'apple-touch-icon-precomposed')
        webAppLogoLink.setAttribute('href', webAppLogo)
        head.appendChild(webAppLogoLink)
      }

      // site_config配置域名
      // if (process.env.NODE_ENV === 'production') {
      //   console.warn('生产环境_cdn域名:', config.site_config.configValue.upload_cdn)
      // } else {
      //   console.log('测试环境_cdn域名:', config.site_config.configValue.upload_cdn)
      // }

      //im角标数量
      this.toTryUpdateNoread()

      this.initTheme()
      this.appReady = true
    },
    openBrowser() {
      let type = this.isWeixin()
      var u = navigator.userAgent
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
      if (type == 1 && isiOS) {
        this.isiOS = true
      } else if (type == 1 && isAndroid) {
        this.isAndroid = true
      } else if (type == 2 && isiOS) {
        this.isiOS = true
      } else if (type == 2 && isAndroid) {
        this.isAndroid = true
      }
    },
    isWeixin() {
      var u = navigator.userAgent
      var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 //android终端
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) //ios终端
      var ua = navigator.userAgent.toLowerCase()
      if (ua.match(/MicroMessenger/i) == 'micromessenger' || ua.match(/WeiBo/i) == 'weibo') {
        return 1 //微信
      } else if (ua.match(/QQ\/[0-9]/i)) {
        return 2 //安卓qq
      }
      return 0
    },
    initTheme() {
      this.$vuetify.theme.themes = {
        light: {
          buttonColor: this.appTheme.buttonColor || this.appTheme.headerBgColor,
          buttonFrontColor: this.appTheme.buttonFrontColor || '#FFF',
          primary: this.appTheme.themeColor || '#db443c',
          primary2: this.appTheme.themeColor2 || this.appTheme.themeColor || '#db443c',
          primary3: this.appTheme.themeColor3 || this.appTheme.themeColor || '#db443c',
          secondary: this.appTheme.secondaryColor || '#ff731e',
          headerBgColor: this.appTheme.headerBgColor || '#db443c', //头部bar背景色
          headerColor: this.appTheme.headerColor || '#fff', //头部bar默认字体色
          pageHeaderBgColor: this.appTheme.pageHeaderBgColor || '#fff', //头部bar默认字体色
          accent: '#ff731e',
          front: this.appTheme.frontColor || '#FFF',
          background: this.appTheme.appBackgroundColor || '#eeeeee',
          bottomBgColor: this.appTheme.bottomBgColor || '#fff', //底部bar背景色
          // bottomFrontColor: this.appTheme.bottomFrontColor || '', //底部bar默认字体颜色
          bottominActiveFrontColor: this.appTheme.bottominActiveFrontColor || '', //底部bar默认字体颜色
          bottomActiveFrontColor: this.appTheme.bottomActiveFrontColor || this.appTheme.headerBgColor || '#db443c', //底部bar字体高亮色
          //默认版面头部背景渐变色
          headerBgColorGradient: this.appTheme.headerBgColorGradient || '',
          text333: this.appTheme.text333 || '',
          headerLoginBgColor: this.appTheme.headerLoginBgColor || ''
        }
      }
    },
    updateNoRead() {
      if (
        this.appReady == true &&
        this.token &&
        this.userInfo &&
        this.userInfo.memberType != 3 &&
        this.userInfo.isIm != 0 &&
        this._sysConfig.is_open_im == '1'
      ) { 
        this.$store.dispatch('user/getImFriendApplyLog')
        this.$store.dispatch('user/getImRecent').catch(res => {
          if (res && res.code == '4000210') {
            this.$store.commit('user/setImRecent', [])
            this.$store.commit('user/setImFriendApplyLog', [])
            this.$store.commit('user/updateUserInfo', { isIm: 0 })
          }
        })
      }
    },
    toTryUpdateNoread() {
      if (
        document.visibilityState != 'hidden' &&
        this.appReady == true &&
        this.token &&
        this.userInfo &&
        this.userInfo.memberType != 3 &&
        this.userInfo.isIm != 0 &&
        this._sysConfig.is_open_im == '1'
      ) {
        this.throttleUpdateNoRead()
      }
    }
  },

  watch: {
    $route(to, from) {
      // 处理邀请码问题
      if (to.params.promoteCode && to.params.promoteCode !== '') {
        localStorage.setItem('promoteCode', to.params.promoteCode) // 邀请码
        localStorage.setItem('codeExpireTime', to.params.codeExpireTime) // 存储过期时间
      }
      if (to.meta.pageAnimationDisable == true) {
        this.direction = ''
        return
      }
      const toDepth = to.path.split('/').length
      const fromDepth = from.path.split('/').length
      if (to.path == '/') {
        this.direction = 'slide-right'
      } else if (from.path == '/') {
        this.direction = 'slide-left'
      } else {
        this.direction = toDepth < fromDepth ? 'slide-right' : 'slide-left'
      }
    },
    token(newValue, oldValue) {
      if (newValue) {
        this.updateNoRead()
      }
    }
  }
}
</script>
<style lang="scss">
.mask {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  bottom: 0;
  background: #333;
  width: 100%;

  img {
    max-width: 100%;
    height: auto;
  }
}

.appView {
  position: absolute;
  width: 100%;
  transition: all 0.25s ease-in-out;
}

.slide-left-enter {
  opacity: 0.1;
  transform: translate(50%, 0);
}

.slide-left-leave-active {
  opacity: 0;
  transform: translate(0%, 0);
}

.slide-right-enter {
  opacity: 1;
  transform: translate(0%, 0);
}

.slide-right-leave-active {
  opacity: 0;
  transform: translate(100%, 0);
}

.iconfont {
  font-size: 16px;
}

.vc-picker-item {
  font-size: 14px;
}

.vc-picker {
  //解决ios偶尔picker选择器动画错误
  margin-top: 100vh;
}

.vc-popup-conatiner.on {
  z-index: 100 !important;
}
</style>
